// extracted by mini-css-extract-plugin
module.exports = {"container":"AdditionalNote_container__W2gN_"};